// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-menu {
  font-family: Montserrat, sans-serif;
}

.ant-layout-rtl .navbar-nav .icon-button .default-lang {
  margin-left: 0;
  margin-right: 12px;
}

.ant-menu-title-content {
  font-weight: 400 !important;
  font-size: 14px !important;
}

.ant-menu-item-icon {
  min-width: 4px !important;
}

.ant-menu-item-group-title {
  font-weight: 600 !important;
  font-size: 12px !important;
  line-height: 14.63px !important;
  letter-spacing: 3% !important;
  color: rgb(161, 161, 161) !important;
}

.ant-menu-title-content {
  color: #000 !important;
}

.ant-menu-item-icon {
  color: #000 !important;
}

.ant-menu-submenu-selected .ant-menu-submenu-title {
  background-color: rgba(102, 192, 255, 0.1) !important;
}

.ant-menu-item-selected {
  background-color: rgba(102, 192, 255, 0.2) !important;
}

.ant-menu-item::after {
  border: 1px solid #66c0ff !important;
}

.ant-menu-item-active .ant-menu-title-content,
.ant-menu-item-active svg {
  color: rgb(102, 192, 255) !important;
}

.ant-menu-submenu-active .ant-menu-submenu-title {
  color: rgb(102, 192, 255) !important;
}
.ant-menu-submenu-active .ant-menu-submenu-title .ant-menu-title-content,
.ant-menu-submenu-active .ant-menu-submenu-title .ant-menu-item-icon {
  color: rgb(102, 192, 255) !important;
}

[data-theme=dark] .ant-menu-title-content {
  color: rgb(180, 190, 210) !important;
}
[data-theme=dark] .ant-menu-item-icon {
  color: rgb(180, 190, 210) !important;
}
[data-theme=dark] .ant-menu-item-group-title {
  color: rgba(255, 255, 255, 0.6) !important;
}
[data-theme=dark] .ant-menu-item-active .ant-menu-title-content,
[data-theme=dark] .ant-menu-item-active svg {
  color: rgb(102, 192, 255) !important;
}
[data-theme=dark] .ant-menu-submenu-active .ant-menu-submenu-title {
  color: rgb(102, 192, 255) !important;
}
[data-theme=dark] .ant-menu-submenu-active .ant-menu-submenu-title .ant-menu-title-content,
[data-theme=dark] .ant-menu-submenu-active .ant-menu-submenu-title .ant-menu-item-icon {
  color: rgb(102, 192, 255) !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/components/sidebar.scss"],"names":[],"mappings":"AAAA;EACE,mCAAA;AACF;;AAKM;EACE,cAAA;EACA,kBAAA;AAFR;;AAQA;EACE,2BAAA;EACA,0BAAA;AALF;;AAQA;EACE,yBAAA;AALF;;AAQA;EACE,2BAAA;EACA,0BAAA;EACA,+BAAA;EACA,6BAAA;EACA,oCAAA;AALF;;AAQA;EACE,sBAAA;AALF;;AAQA;EACE,sBAAA;AALF;;AASE;EACE,qDAAA;AANJ;;AAUA;EACE,qDAAA;AAPF;;AAUA;EACE,oCAAA;AAPF;;AAWE;;EAEE,oCAAA;AARJ;;AAaE;EACE,oCAAA;AAVJ;AAWI;;EAEE,oCAAA;AATN;;AAeE;EACE,oCAAA;AAZJ;AAeE;EACE,oCAAA;AAbJ;AAgBE;EACE,0CAAA;AAdJ;AAkBI;;EAEE,oCAAA;AAhBN;AAqBI;EACE,oCAAA;AAnBN;AAoBM;;EAEE,oCAAA;AAlBR","sourcesContent":[".ant-menu {\n  font-family: Montserrat, sans-serif;\n}\n\n.ant-layout-rtl {\n  .navbar-nav {\n    .icon-button {\n      .default-lang {\n        margin-left: 0;\n        margin-right: 12px;\n      }\n    }\n  }\n}\n\n.ant-menu-title-content {\n  font-weight: 400 !important;\n  font-size: 14px !important;\n}\n\n.ant-menu-item-icon {\n  min-width: 4px !important;\n}\n\n.ant-menu-item-group-title {\n  font-weight: 600 !important;\n  font-size: 12px !important;\n  line-height: 14.63px !important;\n  letter-spacing: 3% !important;\n  color: rgba(161, 161, 161, 1) !important;\n}\n\n.ant-menu-title-content {\n  color: #000 !important;\n}\n\n.ant-menu-item-icon {\n  color: #000 !important;\n}\n\n.ant-menu-submenu-selected {\n  .ant-menu-submenu-title {\n    background-color: rgba(102, 192, 255, 0.1) !important;\n  }\n}\n\n.ant-menu-item-selected {\n  background-color: rgba(102, 192, 255, 0.2) !important;\n}\n\n.ant-menu-item::after {\n  border: 1px solid #66c0ff !important;\n}\n\n.ant-menu-item-active {\n  .ant-menu-title-content,\n  svg {\n    color: rgba(102, 192, 255, 1) !important;\n  }\n}\n\n.ant-menu-submenu-active {\n  .ant-menu-submenu-title {\n    color: rgba(102, 192, 255, 1) !important;\n    .ant-menu-title-content,\n    .ant-menu-item-icon {\n      color: rgba(102, 192, 255, 1) !important;\n    }\n  }\n}\n\n[data-theme='dark'] {\n  .ant-menu-title-content {\n    color: rgb(180, 190, 210) !important;\n  }\n\n  .ant-menu-item-icon {\n    color: rgb(180, 190, 210) !important;\n  }\n\n  .ant-menu-item-group-title {\n    color: rgba(255, 255, 255, 0.6) !important;\n  }\n\n  .ant-menu-item-active {\n    .ant-menu-title-content,\n    svg {\n      color: rgba(102, 192, 255, 1) !important;\n    }\n  }\n\n  .ant-menu-submenu-active {\n    .ant-menu-submenu-title {\n      color: rgba(102, 192, 255, 1) !important;\n      .ant-menu-title-content,\n      .ant-menu-item-icon {\n        color: rgba(102, 192, 255, 1) !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
